import React from "react";
import { Navigate } from "react-router-dom";

/**
 * Iter-267 §2: `/jobs/documents` is now a redirect. The applicant profile
 * and document library live on ONE screen at `/jobs/profile#docs`.
 * We keep this route (with the same file name and default export) so old
 * links from the wizard, emails, and previously-indexed pages don't 404.
 */
export default function JobDocumentsPage() {
  return <Navigate to="/jobs/profile#docs" replace />;
}
